import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {FacilitiesService} from "../../services/facilities.service";
import {AuthenticationService} from "../../services/authentication.service";

@Component({
  selector: 'app-facility-details',
  templateUrl: './facility-details.component.html',
  styleUrls: ['./facility-details.component.css'],
})

export class FacilityDetailsComponent implements OnInit {

  facilityId: string | null
  organizationId: string | null
  facility: any
  loading = true

  constructor(private route: ActivatedRoute,
              private facilitiesService: FacilitiesService,
              private router: Router,
              public authenticationService: AuthenticationService){
  }
  ngOnInit() {
    this.getFacilityId()
    this.getFacilityById()
  }

  getFacilityId(){
    this.facilityId = this.route.snapshot.paramMap.get('facilityId')
    this.organizationId = this.route.snapshot.paramMap.get('organizationId')
  }

  canEdit(): boolean {
    return this.authenticationService.canEditFacility(Number(this.organizationId), Number(this.facilityId));
  }

  canManageOrg(): boolean {
    return this.authenticationService.canManageOrg(Number(this.organizationId));
  }

  getFacilityById(){
    if(this.facilityId){
      this.loading = true
      this.facilitiesService.getFacilityById(this.facilityId).subscribe({
        next: response => {
          this.facility = response
          this.loading = false
        },
        error: () => {
          // 403/404 etc. — render no UI for this facility.
          this.facility = null
          this.loading = false
        },
      })
    } else {
      this.loading = false
    }
  }

  goToFacilityEditing(){
    if(this.facilityId){
      this.router.navigate(['edit'], {relativeTo:this.route})
    }
  }
}
